import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, Tenant } from '@/shared/types';
import { sessionService } from '@/shared/services/session.service';

interface ImpersonationState {
    isImpersonating: boolean;
    isSelectorOpen: boolean;
    originalAdminUser: any | null;
    originalAdminToken: string | null;
    originalAdminRefreshToken: string | null;
    targetUser: User | null;
    targetTenant: Tenant | null;
    loading: boolean;
    error: string | null;
}

// Intentar restaurar estado desde sessionService si fuera necesario, 
// o simplemente confiar en que al recargar el "isImpersonating" se pierde y volvemos a ser admin?
// Mejor manejarlo en memoria y si refresca volvemos a ser admin, a menos que guardemos la "original session".

const initialState: ImpersonationState = {
    isImpersonating: false,
    isSelectorOpen: false,
    originalAdminUser: null,
    originalAdminToken: null,
    originalAdminRefreshToken: null,
    targetUser: null,
    targetTenant: null,
    loading: false,
    error: null,
};

const impersonationSlice = createSlice({
    name: 'impersonation',
    initialState,
    reducers: {
        openSelector: (state) => {
            state.isSelectorOpen = true;
        },
        closeSelector: (state) => {
            state.isSelectorOpen = false;
        },
        startImpersonation: (state, action: PayloadAction<{
            adminUser: any;
            adminToken: string;
            adminRefreshToken: string;
            targetUser: User;
        }>) => {
            state.isImpersonating = true;
            state.isSelectorOpen = false;
            state.originalAdminUser = action.payload.adminUser;
            state.originalAdminToken = action.payload.adminToken;
            state.originalAdminRefreshToken = action.payload.adminRefreshToken;
            state.targetUser = action.payload.targetUser;
            state.error = null;
        },
        stopImpersonation: (state) => {
            state.isImpersonating = false;
            state.isSelectorOpen = false;
            state.originalAdminUser = null;
            state.originalAdminToken = null;
            state.originalAdminRefreshToken = null;
            state.targetUser = null;
            state.targetTenant = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

export const {
    openSelector,
    closeSelector,
    startImpersonation,
    stopImpersonation,
    setLoading,
    setError
} = impersonationSlice.actions;

export default impersonationSlice.reducer;
